/*
 * NoDataComponent
 *
 * This component is common for all the pages which does't have response
 *
 */

import React, { Component} from 'react';

export default class NoDataComponent extends Component {
	constructor(props){
		super(props);
	}
	render() {
    	return (
    		<p className="no-data-cls">{this.props.message ? this.props.message : 'No record exists'}</p>
		);
  	}
}
